<dx-data-grid
  #subversionsGridRef
  *var="mode() as mode"
  class="ag-grid__component"
  [dataSource]="subversions ?? []"
  [keyExpr]="BaseModelKeys.dbId"
  [showBorders]="false"
  [focusedRowEnabled]="false"
  [hoverStateEnabled]="true"
  [columnAutoWidth]="false"
  [columnHidingEnabled]="false"
  [scrollLeft]="true"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  [renderAsync]="true"
  [wordWrapEnabled]="true"
  [noDataText]="mode === 'shot' ? emptyMessage : ''"
  [showColumnHeaders]="showColumnHeaders()"
  height="100%"
  (onSelectionChanged)="onSubversionChanged($event)"
>
  <dxo-selection mode="single"></dxo-selection>
  <dxo-filter-row [visible]="mode === 'shot'"></dxo-filter-row>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-editing
    mode="row"
    [allowUpdating]="false"
    [allowAdding]="false"
    [allowDeleting]="false"
    [useIcons]="true"
    [confirmDelete]="true"
  ></dxo-editing>

  <dxi-column
    [dataField]="UserAgreementManagementKeys.language"
    caption="Language"
    [width]="100"
    [visible]="mode !== 'shot'"
    [lookup]="{dataSource: supportedLanguagesLookup, valueExpr: LookupKeys.value, displayExpr: LookupKeys.description}"
    [sortIndex]="0"
    [sortOrder]="'asc'"
    [calculateSortValue]="getLanguageDescription"
  ></dxi-column>

  <dxi-column
    [dataField]="UserAgreementManagementKeys.fileVersion"
    caption="Version"
    [width]="75"
  ></dxi-column>

  <dxi-column
    [dataField]="UserAgreementManagementKeys.agreementStatus"
    caption="Status"
    [width]="90"
    [visible]="mode === 'shot'"
    [lookup]="{dataSource: userAgreementStatusesLookup, valueExpr: LookupKeys.value, displayExpr: LookupKeys.description}"
    cellTemplate="statusCellTemplate"
  >
    <div *dxTemplate="let cell of 'statusCellTemplate'">
      <ng-container [ngSwitch]="cell.value">
        <span *ngSwitchCase="UserAgreementStatus.draft" class="badge bg-warning text-dark">DRAFT</span>
        <span *ngSwitchCase="UserAgreementStatus.published" class="badge bg-success">PUBLISHED</span>
        <span *ngSwitchCase="UserAgreementStatus.archived" class="badge bg-secondary">ARCHIVED</span>
        <span *ngSwitchDefault class="">{{ cell.value }}</span>
      </ng-container>
    </div>
  </dxi-column>

  <dxi-column
    [width]="180"
    [dataField]="BaseModelKeys.updatedDate"
    caption="Published Date"
    [allowEditing]="false"
    [dataType]="'date'"
    [sortIndex]="1"
    [sortOrder]="'desc'"
    [format]="dateFormat"
  ></dxi-column>

  <dxi-column
    caption="Published By"
    dataField="modifiedByAgent"
    [width]="350"
  ></dxi-column>
</dx-data-grid>

